import processEnvPublic from 'unlikely-env/public'

export function getBranchEnv() {
  return processEnvPublic('NEXT_PUBLIC_ENV')
}
